window.onload = function() {
  (function ($) {
    var $flickity = $('.flickity-custom-slideshow');
    if($flickity.length > 0) {
      var autoplay = false;
      if($flickity.data('autoplay')) {
        autoplay = $flickity.data('autoplay');
      }
      var $scaleBar = $('.header-slideshow-scale-nav'); 
      var $scaleBarPointer = $('.header-slideshow-scale-nav svg'); 
      $flickity.flickity({
        cellAlign: 'left',
        contain: true,
        setGallerySize: false,
        autoPlay: autoplay
      });
      var flkty = $flickity.data('flickity');
      $flickity.on( 'scroll.flickity', function( event, progress ) {
        progress = Math.max( 0, Math.min( 1, progress ) );
        $scaleBarPointer.css('left', progress * 100 + '%'); 
      });
      $flickity.on( 'change.flickity', function( event, index ) {
        console.log( 'Slide changed to ' + index );
        var activeText = $(flkty.selectedElement).attr('data-active-text');
        $('.header-slideshow-scale-nav-active-text').text(activeText);
        $('.header-slideshow-info p:last-child').text('000' + (index+1));
        if($('.is-selected video').length > 0) {
          $('.is-selected video')[0].play(); 
        }
      });
  
      if($('.header-slideshow .slide-1 video').length > 0) {
        $('.header-slideshow .slide-1 video')[0].play(); 
      }
  
      var activeText = $(flkty.selectedElement).attr('data-active-text');
      $('.header-slideshow-scale-nav-active-text').text(activeText);      
    }
  })(window.theme.jQuery); 
}